export default {
  headerBackButtonLabel: 'Back',
};
